import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
  author?: string;
  publishedDate?: string;
}

const SEOCmp: React.FC<SEOProps> = ({
  title,
  description,
  image,
  url,
  type = 'website',
  author,
  publishedDate,
}) => {
  const siteName = 'Gazete Bayii';
  const fullTitle = title ? `${title} - ${siteName}` : siteName;
  const defaultDescription = 'Gazete Bayii - Gazetelerin Ortak Noktası. En güncel haberler, köşe yazıları ve son dakika gelişmeleri.';
  const metaDescription = description || defaultDescription;
  const siteUrl = window.location.origin;
  const canonicalUrl = url || window.location.href;

  const structuredData = type === 'article' ? {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    "headline": title,
    "image": [image],
    "datePublished": publishedDate,
    "author": {
      "@type": "Person",
      "name": author || siteName
    },
    "publisher": {
      "@type": "Organization",
      "name": siteName,
      "logo": {
        "@type": "ImageObject",
        "url": `${siteUrl}/favicon.ico`
      }
    }
  } : null;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      {image && <meta property="og:image" content={image} />}
      <meta property="og:site_name" content={siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      {image && <meta name="twitter:image" content={image} />}

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOCmp;
